/**
 * WS Load More
 *
 * Works on two pages:
 *
 * 1. /collections  (collection list)
 *    - data-ws-load-more + data-next-url on a static wrapper div
 *    - grid: #ws-lm-grid
 *
 * 2. /collections/*  (product grid)
 *    - data-ws-load-more on the outer section div (never touched by Dawn AJAX)
 *    - next URL: <meta name="ws-lm-next-url"> inside #ProductGridContainer
 *      (Dawn re-renders that container on filter/sort, keeping the meta fresh)
 *    - grid: #product-grid
 */

(function () {
  'use strict';

  /* ── next-url helpers ─────────────────────────────────────────── */

  function readNextUrl(container) {
    // Product-grid page: URL lives in a <meta> tag inside ProductGridContainer
    var meta = container.querySelector('meta[name="ws-lm-next-url"]');
    if (meta) return meta.getAttribute('content') || '';
    // Collection-list page: URL lives in data attribute on the wrapper
    return container.dataset.nextUrl || '';
  }

  function writeNextUrl(container, url) {
    var meta = container.querySelector('meta[name="ws-lm-next-url"]');
    if (meta) {
      meta.setAttribute('content', url);
    } else {
      container.dataset.nextUrl = url;
    }
  }

  /* ── grid helper ──────────────────────────────────────────────── */

  function getGrid(container) {
    return container.querySelector('#ws-lm-grid') ||
           container.querySelector('#product-grid');
  }

  /* ── event delegation (survives Dawn AJAX re-renders) ─────────── */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#ws-lm-btn');
    if (!btn || btn.disabled) return;

    var container = btn.closest('[data-ws-load-more]');
    if (!container) return;

    var nextUrl = readNextUrl(container);
    if (!nextUrl) return;

    doLoadMore(container, btn, nextUrl);
  });

  /* ── core fetch & inject ──────────────────────────────────────── */

  function mergeCurrentSortAndFilters(nextUrl) {
    // paginate.next.url only has ?page=N — merge in any sort_by / filter params
    // that the user has applied (they live in window.location.search).
    var live   = new URLSearchParams(window.location.search);
    var target = new URLSearchParams(nextUrl.split('?')[1] || '');

    // Copy every param from the current URL except 'page' (we keep target's page)
    live.forEach(function (val, key) {
      if (key !== 'page') target.set(key, val);
    });

    var base = nextUrl.split('?')[0];
    return base + '?' + target.toString();
  }

  function doLoadMore(container, btn, nextUrl) {
    // Ensure sort_by and active filters are included in the next-page URL
    nextUrl = mergeCurrentSortAndFilters(nextUrl);

    // Loading state
    btn.disabled = true;
    btn.classList.add('ws-lm-btn--loading');
    var btnText = btn.querySelector('.ws-lm-btn-text');
    if (btnText) btnText.textContent = 'Loading…';

    fetch(nextUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        // ── 1. Append new items ──────────────────────────────────
        var grid = getGrid(container);
        if (!grid) throw new Error('grid not found');

        var newGrid = doc.querySelector('#' + grid.id);
        if (!newGrid) throw new Error('new grid not found in fetched page');

        newGrid.querySelectorAll('.ws-lm-item').forEach(function (item) {
          grid.appendChild(item);
        });

        // ── 2. Read next URL from fetched page ───────────────────
        var newNextUrl = '';
        var newMeta = doc.querySelector('meta[name="ws-lm-next-url"]');
        if (newMeta) {
          newNextUrl = newMeta.getAttribute('content') || '';
        } else {
          var newContainer = doc.querySelector('[data-ws-load-more]');
          if (newContainer) newNextUrl = newContainer.dataset.nextUrl || '';
        }

        writeNextUrl(container, newNextUrl);

        // ── 3. Update progress ───────────────────────────────────
        var totalEl = container.querySelector('.ws-lm-total');
        var total = totalEl ? parseInt(totalEl.dataset.total, 10) : 0;
        var shown = grid.querySelectorAll('.ws-lm-item').length;

        var barText = container.querySelector('#ws-lm-bar-text');
        if (barText && total > 0) {
          barText.innerHTML = 'Showing <strong>' + shown + '</strong> of <strong>' + total + '</strong>';
        }

        var barFill = container.querySelector('#ws-lm-bar-fill');
        if (barFill && total > 0) {
          barFill.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
        }

        // ── 4. Hide button when all loaded ───────────────────────
        if (!newNextUrl) {
          var footer = container.querySelector('.ws-lm-footer');
          if (footer) footer.classList.add('ws-lm-footer--done');
        }
      })
      .catch(function (err) {
        console.error('[ws-load-more] error:', err);
      })
      .finally(function () {
        var currentBtn = container.querySelector('#ws-lm-btn');
        if (currentBtn) {
          currentBtn.disabled = false;
          currentBtn.classList.remove('ws-lm-btn--loading');
          var t = currentBtn.querySelector('.ws-lm-btn-text');
          if (t) t.textContent = currentBtn.dataset.defaultText || 'Load More';
        }
      });
  }

})();
